import { render, staticRenderFns } from "./approve.vue?vue&type=template&id=7661b45e&scoped=true"
import script from "./approve.vue?vue&type=script&lang=js"
export * from "./approve.vue?vue&type=script&lang=js"
import style0 from "./approve.vue?vue&type=style&index=0&id=7661b45e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7661b45e",
  null
  
)

export default component.exports